const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 21.75A3.75 3.75 0 0 1 2.25 18V6A3.75 3.75 0 0 1 6 2.25h3.75a.75.75 0 0 1 0 1.5H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25h12A2.25 2.25 0 0 0 20.25 18v-5.75a.75.75 0 0 1 1.5 0V18A3.75 3.75 0 0 1 18 21.75z"/><path d="M21.435 1.435a.8.8 0 1 1 1.13 1.13L13.931 11.2H18a.8.8 0 1 1 0 1.6h-6a.8.8 0 0 1-.8-.8V6a.8.8 0 1 1 1.6 0v4.07z"/></svg>';
export {
  a as w
};
